import { useMediaQuery } from "@mui/material";

const useIsMobile = () => {
    return useMediaQuery("(max-width:500px)");
};

export default useIsMobile;
